module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg22.284c9ae3.jpg";